import { FiTrendingUp } from "react-icons/fi";
import screen from "../../assets/img/app/terakkim.jpg";

/**
 * Uygulamanın Terakkim ekranı, telefon çerçevesinde. Görüntü simülatörden
 * alınmış gerçek ekran (assets/img/app/terakkim.jpg); arayüz değişince
 * aynı yolla yenilenmeli.
 */
export default function PhoneMockup({ className = "" }) {
  return (
    <div className={`relative ${className}`}>
      {/* Arka ışık: telefonla birlikte yavaşça açılır (bulanıklık sabit, animasyon yalnız opacity) */}
      <div className="absolute -inset-10 rounded-full bg-terakkiPrimary/25 blur-3xl animate-hero-in [animation-delay:.2s] motion-reduce:animate-none" aria-hidden />
      <div className="relative mx-auto w-[280px] rounded-[2.8rem] bg-terakkiInk p-2.5 shadow-2xl shadow-terakkiInk/40 animate-hero-phone [animation-delay:.35s] motion-reduce:animate-none">
        <img
          src={screen}
          alt="Terakki uygulamasında Terakkim ekranı: günlük hedefler ve ilerleme"
          className="block h-auto w-full rounded-[2.2rem]"
          width={512}
          height={1000}
        />
      </div>

      {/* Yüzen küçük kartlar: telefondan sonra sırayla belirir, sonra süzülür */}
      <div
        aria-hidden
        className="absolute -left-6 top-24 hidden sm:block animate-pop-in [animation-delay:1s] motion-reduce:animate-none"
      >
        <div className="flex items-center gap-2 rounded-2xl bg-white/90 px-3 py-2 shadow-xl shadow-terakkiPrimaryDark/15 backdrop-blur animate-hero-float motion-reduce:animate-none">
          <FiTrendingUp className="text-terakkiPrimaryDark" size={18} />
          <span className="text-xs leading-tight text-terakkiInk">
            <span className="block font-SemiBold">7 gün</span>
            <span className="text-terakkiNeutral">kesintisiz</span>
          </span>
        </div>
      </div>
      <div
        aria-hidden
        className="absolute -right-6 bottom-24 hidden sm:block animate-pop-in [animation-delay:1.25s] motion-reduce:animate-none"
      >
        <div
          className="flex items-center gap-2 rounded-2xl bg-white/90 px-3 py-2 shadow-xl shadow-terakkiPrimaryDark/15 backdrop-blur animate-hero-float motion-reduce:animate-none"
          style={{ animationDelay: "1.5s" }}
        >
          <span className="h-2.5 w-2.5 rounded-full bg-terakkiPrimary" />
          <span className="text-xs leading-tight text-terakkiInk">
            <span className="block font-SemiBold">Grup haftası</span>
            <span className="text-terakkiNeutral">%92 tamamlandı</span>
          </span>
        </div>
      </div>
    </div>
  );
}
